module.exports = "/fonts/vendor/cryptocoins-icons/webcryptocoins.woff?194ac4725d0152963c9b383933e38a49";